import apiClient, { plainApiClient } from "..";

export const familyMembers = ({ familyId, signal }) => {
  return apiClient.get(`families/${familyId}/members`, { signal });
};

export const getBankDetails = ({ client_id }) => {
  return apiClient.get(`clients/${client_id}/profile`);
};

export const getContact = ({ client_id }) => {
  return apiClient.get(`clients/${client_id}/contactdetails`);
};

export const getLiaison = ({ client_id, la_officers_id }) => {
  return apiClient.get(
    `clients/${client_id}/laisonofficers/${la_officers_id}/profiledetails`
  );
};

export const deleteProfile = ({ pic_id }) => {
  return plainApiClient.delete(`userProfilePics/${pic_id}`);
};

export const getUnlockAcc = () => {
  return apiClient.get("lockeduseraccounts");
};
